export default __webpack_public_path__ + "b02f1aced33a8485168d29e6ec88caa6.png";